// Uses the user's locale on purpose; this matches the pre-consolidation local helpers.
export function formatShortDateTime(value: string | null | undefined): string {
  if (!value) return '-';
  return new Date(value).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
